/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLTI1p1Provider } from './BaseLTI1p1Provider';
const FinalizedLTI1p1ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['finalized', /* #__PURE__ */ parsers.exactly(true)],
]), BaseLTI1p1Provider);
export class FinalizedLTI1p1Provider extends BaseLTI1p1Provider {
    static decode(input) {
        return FinalizedLTI1p1ProviderParser.decode(input).map(res => new FinalizedLTI1p1Provider(res));
    }
    static unsafeDecode(input) {
        return FinalizedLTI1p1Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FinalizedLTI1p1ProviderParser.encode(data);
    }
    static schema() {
        return FinalizedLTI1p1ProviderParser.schema();
    }
}
